import {
  useFormField
} from "../__chunks/5QHNNZNE.js";
import {
  FormContext
} from "../__chunks/P3I4MECH.js";
import {
  useCheckbox
} from "../__chunks/3CJV7UYE.js";
import {
  useCheckboxStore
} from "../__chunks/6TMY6IFR.js";
import "../__chunks/M5KYRTQG.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-checkbox.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useFormCheckbox = createHook(
  (_a) => {
    var _b = _a, { store, name: nameProp, value, checked, defaultChecked } = _b, props = __objRest(_b, ["store", "name", "value", "checked", "defaultChecked"]);
    const context = useContext(FormContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component"
    );
    const name = `${nameProp}`;
    const checkboxStore = useCheckboxStore({
      value: store.useValue(name),
      setValue: (value2) => store == null ? void 0 : store.setValue(name, value2)
    });
    props = useCheckbox(__spreadValues({ store: checkboxStore, value, checked }, props));
    props = useFormField(__spreadValues({
      store,
      name,
      "aria-labelledby": void 0
    }, props));
    return props;
  }
);
var FormCheckbox = createMemoComponent(
  (props) => {
    const htmlProps = useFormCheckbox(props);
    return createElement("input", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  FormCheckbox.displayName = "FormCheckbox";
}
export {
  FormCheckbox,
  useFormCheckbox
};
